import React, { memo } from 'react'
import Grid from '@mui/material/Grid2'
import Container from '@mui/material/Container'
import { Box } from '@mui/material'
import sx from './styles'

const ContainerComponent = ({
  backgroundGray,
  sx: sxProp,
  children,
}) => {
  return (
    <>
      {
        backgroundGray
          ? (
            <Box
              className="ContainerComponent-root"
              sx={{ ...sx.rootGray, ...sxProp }}
            >
              <Grid
                sx={sx.gridContainer}
                justifyContent="center"
              >
                {children}
              </Grid>
            </Box>
          )
          : (
            <Container
              maxWidth="lg"
              className="ContainerComponent-root"
              sx={{ ...sx.root, ...sxProp }}
            >
              <Grid
                sx={sx.gridContainer}
                justifyContent="center"
              >
                {children}
              </Grid>
            </Container>
          )
      }
    </>
  )
}

export default memo(ContainerComponent)
